/** มือจับกุม (lane C4 skeleton): steel + maroon, motif chips. Built from swordKit via families/handArtGen.ts; polish later. */
import { makeHandArt } from '../families/handArtGen';

export const ARRESTHAND_FX: ReturnType<typeof makeHandArt> = makeHandArt('chain-hold', { a: 'steel', b: 'maroon', motif: 'chips' }, [
  ['ah-grip', 'grab'],
  ['ah-throw', 'grab'],
  ['ah-chain', 'throw', 5],
  ['ah-seal', 'palm', 2],
  ['ah-sweep', 'ring', 5],
  ['ah-interrogate', 'palm', 2],
  ['ah-decree', 'buff'],
  ['ah-imperial', 'power', 2.4],
]);
